
import React, { useState, useEffect } from 'react';
import sanityClient from '../sanity';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import SeoMeta from '../components/SeoMeta';
import '../styles/ResourcePage.css';
import '../styles/PageHero.css';

function ResourcesPage() {
    const [resources, setResources] = useState([]);

    useEffect(() => {
        sanityClient
            .fetch(`*[_type == "resource"]{title, description, "fileUrl": file.asset->url}`)
            .then((data) => setResources(data))
            .catch(console.error);
    }, []);

    // ✅ Force download handler
    const handleDownload = (url, filename) => {
        fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = filename || "resource.pdf";
                link.click();
                window.URL.revokeObjectURL(link.href);
            })
            .catch((err) => console.error("Download failed:", err));
    };

    return (
        <div className="resources-page">
            <SeoMeta
                title="Legal Resources | Ziyad Attorneys, Ethiopia"
                description="Browse legal documents and resources from Ziyad Attorneys in Ethiopia."
            />

                        {/* Hero Section */}
            <div
                className="resources-hero page-photo-hero"
                style={{
                    backgroundImage:  "url(/rbi.jpg)" , 
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <div
                    className="resources-hero-text"
                    style={{
                        position: 'absolute',
                        bottom: '30px',
                        textAlign: 'center'
                    }}
                >
                    <h1 className="resources-title page-hero-title">
                        Legal <span className="highlight">Resources</span>
                    </h1>
                    <p className="resources-subtitle page-hero-subtitle">Browse legal documents.</p>
                    <div className="title-underline"></div>
                </div>
            </div>



            {/* Resources Section */}
            <Container className="resources-container">
                <Row>
                    {resources.length > 0 ? (
                        resources.map((resource, index) => (
                            <Col key={index} md={4} className="mb-4">
                                <Card className="h-100 resource-card">

                                    <Card.Body>
                                        <Card.Title>{resource.title}</Card.Title>
                                        <Card.Text>{resource.description}</Card.Text>
                                        <div className="d-flex gap-2">
                                            {resource.fileUrl && (
                                            <>
                                                <Button
                                                variant="primary"
                                                onClick={() =>
                                                    handleDownload(resource.fileUrl, `${resource.title}.pdf`)
                                                }
                                                >
                                                Download
                                                </Button>

                                                <Button
                                                variant="outline-secondary"
                                                onClick={() => window.open(resource.fileUrl, "_blank")}
                                                >
                                                View
                                                </Button>
                                            </>
                                            )}
                                        </div>
                                        </Card.Body>





                                </Card>
                            </Col>
                        ))
                    ) : (
                        <Col>
                            <Card className="h-100 resource-card">
                                <Card.Body>
                                    <Card.Title>No Resources Available</Card.Title>
                                    <Card.Text>
                                        There are currently no resources available for download. Please check back later.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Container>
        </div>
    );
}

export default ResourcesPage;
